import { render, staticRenderFns } from "./PageLoginV2.vue?vue&type=template&id=51e7ef8f&scoped=true&"
import script from "./PageLoginV2.vue?vue&type=script&lang=js&"
export * from "./PageLoginV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e7ef8f",
  null
  
)

export default component.exports